import React from 'react';

import { Like } from 'pctComponents/atoms';
import { ContentNavigationBtn, MenuHeaderContent } from 'pctComponents/molecules';
import ContentMyProgress from 'pctComponents/molecules/ContentMyProgress';

const normalizeLearningNodeToProgressCollection = (nodeCollection) => {
    const node = nodeCollection?.node;
    const nodeEnrollment = node?.nodeEnrollment;
    const idEnrollment = nodeEnrollment?.idEnrollment || nodeEnrollment?.enrollment?.idEnrollment;

    if (node?.nodeType !== 'LEARNING' || !nodeEnrollment || !idEnrollment) {
        return null;
    }

    const normalizedEnrollment = {
        ...nodeEnrollment,
        idEnrollment,
        idUser: nodeEnrollment.idUser || nodeEnrollment.enrollment?.idUser,
        idTeam: nodeEnrollment.idTeam || nodeEnrollment.enrollment?.idTeam,
    };

    return {
        contentEnrollment: normalizedEnrollment,
        nodeEnrollment: normalizedEnrollment,
        nodeCode: node.nodeCode || nodeEnrollment?.node?.nodeCode,
    };
};

function HeaderContentNavigation({ nodeCollection, configHeaderFooter, scoSingleContent }) {
    

    const contentNavigationCollection =
        nodeCollection?.node?.nodeType === 'LEARNING'
            ? normalizeLearningNodeToProgressCollection(nodeCollection)
            : configHeaderFooter?.contentNavigation
            ? configHeaderFooter?.contentNavigation
            : null;
    
    return configHeaderFooter?.contentNavigation?.questionnaireType !== 'PRE_TEST' ? (
        <div className="contentNavigation">
            {configHeaderFooter?.contentNavigation?.content || scoSingleContent ? (
                <Like
                    direction="invert"
                    collection={{
                        data: scoSingleContent ? scoSingleContent : configHeaderFooter?.contentNavigation?.content,
                        elementType: 'CONTENT',
                        idElement: scoSingleContent
                            ? scoSingleContent.idContentItem
                            : configHeaderFooter?.contentNavigation?.content.idContentItem,
                    }}
                    className="likeNav"
                />
            ) : (
                <></>
            )}

            {(nodeCollection || configHeaderFooter) && (
                <MenuHeaderContent nodeCollection={nodeCollection} configHeaderFooter={configHeaderFooter} />
            )}

            {configHeaderFooter?.contentNavigation && (
                <ContentNavigationBtn
                    direction="prev"
                    text="Anterior"
                    collection={configHeaderFooter?.contentNavigation}
                />
            )}

            {configHeaderFooter?.contentNavigation && (
                <ContentNavigationBtn
                    direction="next"
                    text="Próximo"
                    unlockNext={configHeaderFooter?.unlockNext}
                    collection={configHeaderFooter?.contentNavigation}
                />
            )}
            {/* BOTÃO PARA ACESSAR O MAPA DE CONTEÚDOS */}
            {contentNavigationCollection && (
                <>
                    <ContentMyProgress collection={contentNavigationCollection} />
                </>
            )}
        </div>
    ) : (
        <></>
    );
}

export default HeaderContentNavigation;
